import { makeAutoObservable, runInAction } from 'mobx';
import { HelperCore } from '@/common/dependencies';
import globalStore from '@/store/global';
import { HelpOther } from '@/common/helper';
import chatInputStore from '@/components/chat/ChatInput/store';
import homeSimpleAgentsStore from '@/pages/search-home/components/simple-agents/store';
import genFileTypesStore from '@/pages/search-home/components/gen-file-types/store';


const gaokaoAI={
  "app_icon": "https://p5.ssl.qhimg.com/t110b9a93010d8367d21c01dd32.png",
  "app_icon_on": "https://p0.ssl.qhimg.com/t110b9a93010828ae9ea9c0d212.png",
  "app_intro": "深度拆解复杂任务，自主规划执行，生成图文并茂的分析报告",
  "app_is_hide": "0",
  "category": "gaokao", // 添加category属性以便与其他项保持一致
  "icon": "https://p5.ssl.qhimg.com/t110b9a93010d8367d21c01dd32.png",
  "icon_on": "https://p0.ssl.qhimg.com/t110b9a93010828ae9ea9c0d212.png",
  "intro": "一键生成高考AI志愿单",
  "intro_intent": "通用深度研究工具，自主规划完成用户复杂任务，生成图文并茂的报告的工具，意，如果当前工具集合没有明显适配用户问题的工具，请直接调用此工具。您可将此工具作为默认选项。",
  "is_hide": "0",
  "sort": 2,
  "title": "AI高考填报助手"
}
class Store {
  categories = [];
  curCategoryIdx = -1;
  constructor() {
    makeAutoObservable(this);
    globalStore.whenCloudReady(() => {
      runInAction(() => {
        // 过滤原始categories
        const filteredCategories = globalStore.cloudConfig.assistantAisoFieldCategory.filter((item) => {
          return (+item.is_hide !== 1 && item.category != 'auto')
        });
        
        // 将gaokaoAI添加到数组首位
        this.categories = [gaokaoAI, ...filteredCategories];
      });
    });

    if(!HelperCore.IS_PROD){
      window._fieldCategoryStore = this;
    }
  }

  onCheckedAiso = (state) => {
    runInAction(() => {
      if (state) {
        // this.curCategoryIdx = 0;
      }else {
        this.curCategoryIdx = -1;
      }
    });
  }

  checkCategory = (categoryIdx) => {
    if (this.curCategoryIdx === categoryIdx) {
      return;
    }
    globalStore.robotAiso(true); // 切换超级智能体
    runInAction(() => {
      this.curCategoryIdx = categoryIdx;
    });

  }

  isCheckedCategory = (categoryIdx) => {
    return this.curCategoryIdx === categoryIdx;
  }

  getCheckedCategory = () => {
    
    if (this.curCategoryIdx >= 0) {
      return this.categories[this.curCategoryIdx]?.category ?? '';
    }
    return 'auto';
  }

  switchSuperSo = (flag) => {
    globalStore.robotAiso(flag);

    if (!flag) {
      runInAction(() => {
        this.curCategoryIdx = -1
      })
      
    } 
  }

  setCurrentCate = (data) => {
    // 做同款，统一清掉垂搜、模式
    homeSimpleAgentsStore.reset();
    genFileTypesStore.reset();

    globalStore.robotAiso(true); // 切换超级智能体
    // console.log("data.agent_category_so is", data.agent_category_so)
    const index = this.categories.findIndex((item) => item?.category == data.agent_category_so)

    if (index > -1) { // 查到
      runInAction(() => {
        this.curCategoryIdx = index;
      })
    } else {
      this.curCategoryIdx = -1
    }
    
    chatInputStore.setContent(data.query)
  }

  reset() {
    this.curCategoryIdx = -1
    globalStore.robotAiso(false); // 切换超级智能体
  }
}

const fieldCategoryStore = new Store();
export default fieldCategoryStore;